export async function fetchFileAsBase64(fileUrl: string): Promise<string> {
  const response = await fetch(fileUrl)
  if (!response.ok) {
    throw new Error(
      `Failed to convert File to Base64: Unable to fetch file from URL (${response.statusText})`
    )
  }
  const buffer = await response.arrayBuffer()
  return Buffer.from(buffer).toString('base64')
}
